module.exports = __webpack_public_path__ + "static/media/Florida Nurses Association Logo.df57ea03.jpeg";